import { render, staticRenderFns } from "./StartFromScratchCard.vue?vue&type=template&id=45e84b42&scoped=true"
import script from "./StartFromScratchCard.vue?vue&type=script&lang=js"
export * from "./StartFromScratchCard.vue?vue&type=script&lang=js"
import style0 from "./StartFromScratchCard.vue?vue&type=style&index=0&id=45e84b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e84b42",
  null
  
)

export default component.exports